import React from 'react';
import{ Mail,CircleCheck, Eye, Upload, AlarmClock,File } from "lucide-react";
import { Card,CardHeader,CardDescription,CardContent, CardTitle } from '../ui/card';
import { SectionHeader } from '../ui/sectionHeader';
import { DotSeprated } from '../comp-utils/UploadUtils';
import { humanReadableDate,humanReadableTime } from '../../utils/dateHelper';
// Icon
export const IconType = ({ type }) => {
  switch (type) {
    case 'completed':
      return <CircleCheck className="text-[var(--color-system-positive-2)]" />;
    case 'started':
      return <Mail className="text-[var(--color-system-info-2)]" />;           
    case 'reminder':
      return <AlarmClock className="text-[var(--color-system-warning-2)]" />;
    case 'watching':
      return <Eye className="text-[var(--color-system-warning-2)]" />;  
    case 'upload':
      return <Upload className="text-[var(--color-system-info-2)]" />;  
    case 'file':    
      return <File className="text-[var(--color-system-info-2)]" />;
    case 'circle-filled':
      return <div className='w-5 h-5 rounded-full bg-[var(--color-misc-progress)]'></div>;
    case 'circle':
      return null;
  }
}      
export const TimelineItem = ({ title,description,time,username,type='circle',completed=false,active=false, children, isFirst=false, isLast=false,isProgress=false }) => {
  let topColor = 'bg-[var(--color-neutral-5)]';
  let bottomColor = 'bg-[var(--color-neutral-5)]';
  let iconBg = 'bg-[var(--color-neutral-1)]';
  let iconDimensions = 'w-10 h-10';
  let topHeight = 'h-12';
  let cardMargin = isFirst ? 'mt-0' : 'mt-6';
  
  if(isProgress){
    iconDimensions = 'w-8 h-8'; 
    if(completed){
      type='circle-filled';
      topColor = 'bg-[var(--color-misc-progress)]';
      if (!active){
        bottomColor = 'bg-[var(--color-misc-progress)]';
      }
      iconBg = 'bg-transparent border-2 border-[var(--color-misc-progress)]';
    }else{
      iconBg = 'bg-transparent border-2 border-[var(--color-neutral-5)]';
    }
  }
  
  if(isFirst){
    topColor = 'bg-transparent';
    topHeight = 'h-6';
  }
  if(isLast){
    bottomColor = 'bg-transparent';
  }
  if(isProgress){
    cardMargin = 'mb-10';
    topHeight = 'h-2';
    if(isLast){
      cardMargin = 'mb-0';
    }
  }
  const sideTopCSS = `${topColor} ${topHeight}`;
  return (

    <div className="flex gap-8 items-stretch">
      <div className='items-center flex flex-col justify-stretch'>
        <div className={`w-0.5  ${sideTopCSS}`}></div>
        <div className={`flex items-center justify-center rounded-full ${iconBg} ${iconDimensions}`}>
            <IconType type={type} completed={completed} />
        </div>
        <div className={`w-0.5 flex-1 ${bottomColor}`}></div>
      </div>
      {isProgress ?
      <div className={`${cardMargin} text-[var(--color-neutral-1)]`}>
        <h4 className='font-semibold'>{title}</h4>
        <p className='leading-1 text-[var(--color-neutral-5)]'>{children}</p>
      </div>
      :
      <Card className={`bg-[var(--color-neutral-1)] flex-1 ${cardMargin}`}>
          <CardHeader>
            <CardTitle>{title}</CardTitle>  
            <DotSeprated right={humanReadableDate(time)} left={humanReadableTime(time)} />
            {username}
            <CardDescription>{description}</CardDescription>
          </CardHeader>
          <CardContent>
            {children}
          </CardContent>
        </Card>}
    </div>
  );
}
export const Timeline = ({ children,isProgress=false,heading }) => {
  const count = React.Children.count(children)
  let activeCounted =false;
  let headingColor = 'text-[var(--color-neutral-5)]';
  if(isProgress){
    headingColor = 'text-[var(--color-neutral-1)]';
  }

  return (
    <>
    {heading &&<SectionHeader text={heading} headingColor={headingColor} />}
      <div className="flex flex-col">
        {React.Children.map(children, (child,index) => {
          const isFirst = index === 0;
          const isLast = index ===  count- 1;
          const completed = isProgress && !activeCounted;
          if(child?.props.active){activeCounted = true;}

            if (React.isValidElement(child)) {
              return React.cloneElement(child,{isProgress,isFirst,isLast,completed})
            }
        }
      )}
    </div>
    </>
  );
}
